import React, { useEffect } from "react";
import { useAuth } from '../../auth/AuthContext';
import { useLocation } from 'react-router-dom';
import MenuBar from "../common/MenuPanel";
import FooterPanel from "../common/FooterPanel";
import LoginForm from "../admin/LoginForm";

const AccessDeniedPage = ({ redirectPath }) => {
  const { user,userType } = useAuth();
  const location = useLocation();
  const userData = user?.user;
  const isLoggedIn = !!userType;

  useEffect(() => {
    if (!isLoggedIn) {
      // Store current path in localStorage to redirect after login
      localStorage.setItem("previousPath", location.pathname);
    }
  }, [isLoggedIn, location]);

  return (
    <React.Fragment>
      <div className="container-fluid position-relative p-0">
        <MenuBar />
      </div>
      <div className="container-fluid p-0">
        <div
          className="banner-image_sm"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/2.png)`,
          }}
        >
          <div className="banner-heading text-center wow fadeInDown">
            <h1 className="text-white">Access Denied</h1>
          </div>
        </div>
      </div>
      <div className="container mt-5">
        {isLoggedIn ? (
          <p>You do not have the required permissions to view this page.</p>
        ) : (
          <>
            <p>You must be logged in to access this page.</p>
            <LoginForm redirectPath={redirectPath} />
          </>
        )}
      </div>
      <FooterPanel />
    </React.Fragment>
  );
};

export default AccessDeniedPage;
